import React, { useContext, useMemo } from "react";
import "./index.scss";
import { getAvailableSidesByStep } from "../../../FormulaGenerator/formulaHelpers";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const TreatmentView = ({
  selectStep,
  stepId
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData,
    isPatient,
    setStepFormula
  } = useContext(StepContext);

  function navigateToAutoTreatment() {
    setStepFormula(stepId, dentalData);
    selectStep("restorationSelect");
  }

  const availableSwitchers = useMemo(() => {
    return getAvailableSidesByStep(stepId);
  }, [stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "treatmentView"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: dentalData,
    availableSwitchers: availableSwitchers,
    hideNotUsedSides: false,
    hideJawStateSwitcher: false,
    jawStateEnabled: false
  }), !isPatient && /*#__PURE__*/React.createElement("button", {
    className: "btnPrimary treatmentView-nextBtn",
    onClick: navigateToAutoTreatment
  }, _t("Дополнить план лечения")));
};

export default TreatmentView;